import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import
{
    faAnglesLeft,
    faAngleLeft,
    faAngleRight,
    faAnglesRight
} from '@fortawesome/free-solid-svg-icons';

const Stack =
({
    checking,
    sorting,
    loading,
    pages,
    pagination,
    lastPage,
    handlePage,
    handleSelectPage
}) =>
{
    return (
        <>
            <li className="page-item"><button className="page-link d-flex flex-nowrap" onClick={() => handleSelectPage(1)} disabled={loading === false || pagination === 1}><small><FontAwesomeIcon icon={faAnglesLeft} /></small></button></li>
            <li className="page-item"><button className="page-link d-flex flex-nowrap align-items-center ps-1" onClick={() => handlePage(-1)} disabled={loading === false || pagination === 1}><FontAwesomeIcon icon={faAngleLeft} /><small>{'Anterior'}</small></button></li>

                {
                    <li className="page-item"><button className="page-link d-flex flex-nowrap" onClick={() => handleSelectPage(1)} disabled={loading === false || pagination < 4}><small>{'1 ...'}</small></button></li>
                }

                {
                    pages.map((page, index) =>
                    (
                        checking === false && sorting === false && loading === true && page.page === pagination ?
                            <li key={index} className="page-item"><button className="page-link active d-flex flex-nowrap" onClick={() => handleSelectPage(page.page)} disabled={loading === false}><small>{page.page}</small></button></li> :
                            <li key={index} className="page-item"><button className="page-link d-flex flex-nowrap" onClick={() => handleSelectPage(page.page)} disabled={loading === false}><small>{page.page}</small></button></li>
                    ))
                }

                {
                    <li className="page-item"><button className="page-link d-flex flex-nowrap" onClick={() => handleSelectPage(lastPage)} disabled={loading === false || pagination > (lastPage - 3)}><small>{`... ${lastPage}`}</small></button></li>
                }

            <li className="page-item"><button className="page-link d-flex flex-nowrap align-items-center pe-1" onClick={() => handlePage(1)} disabled={loading === false || pagination === lastPage}><small>{'Siguiente'}</small><FontAwesomeIcon icon={faAngleRight} /></button></li>
            <li className="page-item"><button className="page-link d-flex flex-nowrap align-items-center" onClick={() => handleSelectPage(lastPage)} disabled={loading === false || pagination === lastPage}><small><FontAwesomeIcon icon={faAnglesRight} /></small></button></li>
        </>
    )
}

export default Stack;
